import {
  SUBMIT_DIALOG_ACCEPT,
  SUBMIT_DIALOG_REJECT,
  SUBMIT_DIALOG_CLOSE,
  ENDCAP_POSITION_LOWER,
  ENDCAP_POSITION_UPPER,
  GLOBAL_PROJECT_TYPE_CHAMBER,
  GLOBAL_PROJECT_TYPE_PIPE,
  PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID,
  CHAMBER_TYPE_ID_SC160LP,
  CHAMBER_TYPE_ID_SC310,
  CHAMBER_TYPE_ID_SC740
} from "../lib/types";
import {
  Email,
  Project,
  ChamberBed,
  ChamberRow,
  Background,
  StoneBed,
  Chamber,
  EndCap
} from "../lib/project-build";
import {
  EmailPipe,
  BackgroundPipe,
  PipeBed,
  StoneBedPipe,
  ProjectPipe
} from "../lib/project-build-pipe";
import pipeSelectors from "../lib/pipe-selectors";
import { getRegionById } from "../lib/localization/regions";
import { getLanguageByName } from "../lib/localization/languages";
import { regionIds } from "../lib/localization/regionIds";
import ManifoldSelectors from "../reducers/main-manifold-reducer";
import { ManifoldUtils } from "../lib/manifolds/utils";
import ProjectSelectors from "../reducers/project-reducer";
import SubProjectService from "../lib/services/sub-project-service";
import SubProject from "../lib/sub-project";

export const states = [
  { key: "AL", text: "Alabama" },
  { key: "AK", text: "Alaska" },
  { key: "AZ", text: "Arizona" },
  { key: "AR", text: "Arkansas" },
  { key: "CA", text: "California" },
  { key: "CO", text: "Colorado" },
  { key: "CT", text: "Connecticut" },
  { key: "DC", text: "District of Columbia" },
  { key: "DE", text: "Delaware" },
  { key: "FL", text: "Florida" },
  { key: "GA", text: "Georgia" },
  { key: "HI", text: "Hawaii" },
  { key: "ID", text: "Idaho" },
  { key: "IL", text: "Illinois" },
  { key: "IN", text: "Indiana" },
  { key: "IA", text: "Iowa" },
  { key: "KS", text: "Kansas" },
  { key: "KY", text: "Kentucky" },
  { key: "LA", text: "Louisiana" },
  { key: "ME", text: "Maine" },
  { key: "MD", text: "Maryland" },
  { key: "MA", text: "Massachusetts" },
  { key: "MI", text: "Michigan" },
  { key: "MN", text: "Minnesota" },
  { key: "MS", text: "Mississippi" },
  { key: "MO", text: "Missouri" },
  { key: "MT", text: "Montana" },
  { key: "NE", text: "Nebraska" },
  { key: "NV", text: "Nevada" },
  { key: "NH", text: "New Hampshire" },
  { key: "NJ", text: "New Jersey" },
  { key: "NM", text: "New Mexico" },
  { key: "NY", text: "New York" },
  { key: "NC", text: "North Carolina" },
  { key: "ND", text: "North Dakota" },
  { key: "OH", text: "Ohio" },
  { key: "OK", text: "Oklahoma" },
  { key: "OR", text: "Oregon" },
  { key: "PA", text: "Pennsylvania" },
  { key: "RI", text: "Rhode Island" },
  { key: "SC", text: "South Carolina" },
  { key: "SD", text: "South Dakota" },
  { key: "TN", text: "Tennessee" },
  { key: "TX", text: "Texas" },
  { key: "UT", text: "Utah" },
  { key: "VT", text: "Vermont" },
  { key: "VA", text: "Virginia" },
  { key: "WA", text: "Washington" },
  { key: "WV", text: "West Virginia" },
  { key: "WI", text: "Wisconsin" },
  { key: "WY", text: "Wyoming" }
];

export const CAProvinces = [
  { key: "AB", text: "Alberta" },
  { key: "BC", text: "British Columbia" },
  { key: "MB", text: "Manitoba" },
  { key: "NB", text: "New Brunswick" },
  { key: "NL", text: "Newfoundland and Labrador" },
  { key: "NT", text: "Northwest Territories" },
  { key: "NS", text: "Nova Scotia" },
  { key: "NU", text: "Nunavut" },
  { key: "ON", text: "Ontario" },
  { key: "PE", text: "Prince Edward Island" },
  { key: "QC", text: "Quebec" },
  { key: "SK", text: "Saskatchewan" },
  { key: "YT", text: "Yukon" }
];

export const MXProvinces = [
  { key: "Aguascalientes", text: "Aguascalientes" },
  { key: "Baja California", text: "Baja California" },
  { key: "Baja California Sur", text: "Baja California Sur" },
  { key: "Campeche", text: "Campeche" },
  { key: "Chiapas", text: "Chiapas" },
  { key: "Chihuahua", text: "Chihuahua" },
  { key: "Ciudad de México", text: "Ciudad de México" },
  { key: "Coahuila", text: "Coahuila" },
  { key: "Colima", text: "Colima" },
  { key: "Durango", text: "Durango" },
  { key: "Estado de México", text: "Estado de México" },
  { key: "Guanajuato", text: "Guanajuato" },
  { key: "Guerrero", text: "Guerrero" },
  { key: "Hidalgo", text: "Hidalgo" },
  { key: "Jalisco", text: "Jalisco" },
  { key: "Michoacán", text: "Michoacán" },
  { key: "Morelos", text: "Morelos" },
  { key: "Nayarit", text: "Nayarit" },
  { key: "Nuevo León", text: "Nuevo León" },
  { key: "Oaxaca", text: "Oaxaca" },
  { key: "Puebla", text: "Puebla" },
  { key: "Querétaro", text: "Querétaro" },
  { key: "Quintana Roo", text: "Quintana Roo" },
  { key: "San Luis Potosí", text: "San Luis Potosí" },
  { key: "Sinaloa", text: "Sinaloa" },
  { key: "Sonora", text: "Sonora" },
  { key: "Tabasco", text: "Tabasco" },
  { key: "Tamaulipas", text: "Tamaulipas" },
  { key: "Tlaxcala", text: "Tlaxcala" },
  { key: "Veracruz", text: "Veracruz" },
  { key: "Yucatán", text: "Yucatán" },
  { key: "Zacatecas", text: "Zacatecas" },
];

const getStateAbbreviation = stateValue => {
  const result = states.find(
    state => state.key.toLowerCase() === stateValue.toLowerCase() || state.text.toLowerCase() === stateValue.toLowerCase());
  return result ? result.key : null;
};

const getCAProvincesAbbreviation = stateValue => {
  const result = CAProvinces.find(
    prov => prov.key.toLowerCase() === stateValue.toLowerCase() || prov.text.toLowerCase() === stateValue.toLowerCase());
  return result ? result.key : null;
};
const getMXProvincesAbbreviation = stateValue => {
  const result = MXProvinces.find(
    prov => prov.key.toLowerCase() === stateValue.toLowerCase() || prov.text.toLowerCase() === stateValue.toLowerCase());
  return result ? result.key : null;
};

export const submitAccept = ( props ) => ( dispatch, getState ) => {
  /* get tue current state */
  let state = getState();
  let project;

  let additionalBeds = [];

  let finalizeSubmit = ( project ) => {

    /* if the bridge is present, submit to inventor */
    try {
      if (window._bridge) {
        window._bridge.sendSerializedProject(project.serialize());
      }
    } catch (e) {
      console.error(`Error on finalizeSubmit ${e.message} `);
    }

    /* dispatch action */
    dispatch({
      type: SUBMIT_DIALOG_ACCEPT
    });
  };

  /* if bridge is present, communicate with serialized project */
  if (state.globals.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
    project = buildProjectAutomation()(dispatch, getState);
    if (ProjectSelectors.isMultiBedProject()) {
      // Save the current tab's automation state first
      const currentTabSubProjectId = state.multiBed.selectedTabKey === "overview"
        ? state.multiBed.beds[state.multiBed.beds.length - 1].id
        : state.multiBed.selectedTabKey;

      SubProjectService.syncAutomationProcess(new SubProject(currentTabSubProjectId), props)
        .then(() => {
          // Load all the automation data for beds in the project
          SubProjectService.loadAllSubProjectsAutomationState(state.project.project.id, state)
            .then(chamberBeds => {
              console.log("chamberBeds:: ", chamberBeds);
              project.beds = JSON.stringify(chamberBeds);
              finalizeSubmit(project);
            })
            .catch(error => console.info(`SubProjectService.loadAllSubProjectsAutomationState CATCH ${error.message}`));
        });
    } else {
      finalizeSubmit(project);
    }
  } else if (state.globals.projectType === GLOBAL_PROJECT_TYPE_PIPE) {
    project = buildPipeProjectAutomation()(dispatch, getState);
    if (ProjectSelectors.isMultiBedProject()) {
      // Save the current tab's automation state first
      const currentTabSubProjectId = state.multiBed.selectedTabKey === "overview"
        ? state.multiBed.beds[state.multiBed.beds.length - 1].id
        : state.multiBed.selectedTabKey;
      SubProjectService.syncAutomationProcess(new SubProject(currentTabSubProjectId), state)
        .then(() => {
          SubProjectService.loadAllSubProjectsAutomationState(state.project.project.id, state)
            .then(pipeBeds => {

              project.beds = JSON.stringify(pipeBeds);
              finalizeSubmit(project);
            });
        });
    } else {
      finalizeSubmit(project);
    }
  }
};

export const submitReject = () => dispatch => {
  dispatch({
    type: SUBMIT_DIALOG_REJECT
  });
};

export const closeDialog = () => dispatch => {
  dispatch({
    type: SUBMIT_DIALOG_CLOSE
  });
};

function backgroundToPNG( background ) {
  let image = background.getImage();
  let canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  canvas.getContext("2d").drawImage(image, 0, 0);

  /* extract the base64 enconded bytes(strip the 'data:image/png;base64,') */
  return canvas.toDataURL("image/png").split(",")[1];
}

const formatNum = ( val ) => {
  if (val && typeof val === "number") {
    if (Number.isInteger(val)) {
      return Math.floor(val);
    } else {
      return val.toFixed(2);
    }
  } else {
    return val;
  }
};

/**
 * The Pipes Project automation class.
 */
export const buildPipeProjectAutomation = () => ( dispatch, getState ) => {
  /* get tue current state */
  let state = getState();

  /* collecting all necessary properties */
  let stage = window.konvaStage;
  let scalePixels = state.pipeGlobals.scalePixels;
  let scaleValue = state.pipeGlobals.scaleValue;
  let pipeType = state.pipeGlobals.pipeType.id;
  let pipeFitting = state.pipeGlobals.pipeFitting.id;
  let pipeDiameter = state.pipeGlobals.pipeNominalDiameter.pipeND.in;
  let systemType = state.pipeGlobals.pipeSystemType.id;
  let thermoplasticLiner = state.pipeGlobals.thermoplasticLiner;

  const pipeFlowDirection = state.pipeGlobals.pipeFlowDirection;

  let pipeBedHeight = state.pipeBed.pipeBedDimensions.height.px;
  let pipeBedWidth = state.pipeBed.pipeBedDimensions.width.px;
  let porousStoneAbove = state.pipeGlobals.pipeStoneAbove;
  let porousStoneBelow = state.pipeGlobals.pipeStoneBelow;
  let porosityPercent = state.pipeGlobals.pipeStonePorosity;
  let baseStoneElevation = state.pipeGlobals.pipeInvertElevation;
  let pipePerimeterOffset = state.pipeGlobals.pipePerimeterOffset;
  let totalStorageProvided = state.pipeBed.volume;

  /* is background showing */
  let bgShow = state.background.bgShow;

  /* get the components from stage */
  let background = stage.find("#background")[0];

  /* the project object */
  let project = new ProjectPipe();

  /* set the user localization settings */
  project.setRegion(state.localization.region.name);
  project.setLanguage(state.localization.language.name);
  project.setUnits(state.localization.unit);

  /* extract the pipe bed properties */
  let bedRotation = state.pipeBed.rotation;
  let bedX = state.pipeBed.position.x + state.pipeBed.pipeBedDimensions.x.px;
  let bedY = state.pipeBed.position.y + state.pipeBed.pipeBedDimensions.y.px;
  let bedHeight = pipeBedHeight;
  let bedWidth = pipeBedWidth;

  /* instance the chamber bed serialization object */
  let pipeBd = new PipeBed(bedX, bedY, bedRotation, bedWidth, bedHeight);

  /* Add all pipes elements */
  state.pipeBed.pipeElements
    .forEach(( e ) => {
      pipeBd.addElement(e);
    });

  /* add pipe bed to project */
  project.setPipeBed(pipeBd);

  /* if background is present */
  if (background && bgShow) {
    /* extract the chamber bed properties */
    let bgRotation = background.rotation();
    let bgX = background.x();
    let bgY = background.y();
    let bgHeight = background.height();
    let bgWidth = background.width();
    let bgScaleX = background.scaleX();
    let bgScaleY = background.scaleY();
    /* extracting background data */
    let bgData = backgroundToPNG(background);

    /* instance the background serialization object */
    let bg = new BackgroundPipe(
      bgX,
      bgY,
      bgScaleX,
      bgScaleY,
      bgRotation,
      bgWidth,
      bgHeight,
      bgData
    );
    /* add background to project */
    project.setBackground(bg);
  }

  /* instance the stone bed serialization object */
  let stnBd = new StoneBedPipe();
  let { width, length } = state.pipeBed.dimensions;
  let { x, y } = state.pipeBed.position;

  /* add points */
  stnBd.addPoint(0, x, y);// left up
  stnBd.addPoint(1, x + width.px, y); // right up
  stnBd.addPoint(2, x + width.px, y + length.px); // right down
  stnBd.addPoint(3, x, y + length.px);// left down

  /* add stone bed to project */
  project.setStoneBed(stnBd);

  /* adding metadata and types */
  project.setPipeType(pipeType);
  project.setPipePipeFitting(pipeFitting);
  project.setPipeDiameter(pipeDiameter);
  project.setSystemType(systemType);
  project.setThermoplasticLiner(thermoplasticLiner);
  project.setScaleValue(scaleValue);
  project.setScalePixels(scalePixels);
  project.setPorousStoneAbove(porousStoneAbove);
  project.setPorousStoneBelow(porousStoneBelow);
  project.setPorosityPercent(porosityPercent);
  project.setBaseStoneElevation(baseStoneElevation);
  project.setTotalStorageProvided(totalStorageProvided);

  // Extra values
  project.setPipeFlowDirection(pipeFlowDirection);
  project.setStonePerimeterSeparation(pipePerimeterOffset);

  /* set project email info */
  let email = new EmailPipe();
  let projectInfo = state.project.project || state.project.projectInfo;

  /* init email data */
  email.name = "";
  email.projectname = "";
  email.engineer = "";
  email.location = "";
  email.city = "";
  email.state = "";
  email.country = "";
  email.drawingsURL = "";
  email.boomURL = "";
  email.isInternal = false;

  /* validate email address */
  if (
    state.authentication.user &&
    state.authentication.user.mails &&
    state.authentication.user.mail
  ) {
    /* set the full name */
    let fullName = `${state.authentication.user.displayName}`;
    email.to = state.authentication.user.mail;
    email.fullName = fullName;
    /* collect the initials */
    let initials = fullName.match(/\b\w/g) || [];
    email.engineer = ( ( initials.shift() || "" ) + ( initials.pop() || "" ) ).toUpperCase();
    project.engineer = email.engineer;
  } else {
    console.warn("No user/email present to provide email address for submission", state.authentication.user);
  }

  let projectLanguage = getLanguageByName(project.language);

  if (thermoplasticLiner) {
    email.thermoplasticLiner = state.localization.content[projectLanguage.id].yes;
  } else {
    email.thermoplasticLiner = state.localization.content[projectLanguage.id].no;
  }

  if (projectInfo !== null) {
    try {
      email.name = projectInfo.projectName || email.name;
      email.projectname = projectInfo.projectName || email.projectname;
      if (projectInfo.region === getRegionById(regionIds.usa).name) {
        email.location = getStateAbbreviation(projectInfo.state) || email.location;
        email.unitName = state.localization.content[projectLanguage.id].imperial;
      } else {
        email.location = projectInfo.country || email.location;
        email.unitName = state.localization.content[projectLanguage.id].metric;
      }
      email.state = getStateAbbreviation(projectInfo.state) || email.state;
      email.city = projectInfo.city || email.city;
      email.country = projectInfo.country || email.country;
    } catch (exception) {
      console.error("(projectInfo === null)", exception.message);
    }
  }

  email.pipeType = pipeType;
  email.pipeFitting = pipeFitting;
  email.pipeDiameter = pipeDiameter;
  email.isSoilTightPerforated = pipeFitting === PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID;
  email.systemType = systemType;
  email.requiredvolume = formatNum(state.pipeGlobals.pipeRequiredVolume) || 0;
  email.porosity = formatNum(state.pipeGlobals.pipeStonePorosity) || 0;
  email.stoneBelow = formatNum(state.pipeGlobals.pipeStoneBelow) || 0;
  email.stoneAbove = formatNum(state.pipeGlobals.pipeStoneAbove) || 0;
  email.stoneAbove = formatNum(state.pipeGlobals.pipeStoneAbove) || 0;
  email.avgCover = formatNum(state.calculations.averageCover) || 0;  // TODO: Might need to calculate it!
  email.availableLength = formatNum(state.pipeGlobals.pipeAvailableLength);
  email.availableWidth = formatNum(state.pipeGlobals.pipeAvailableWidth);
  email.installedVolume = formatNum(state.pipeBed.volume) || 0;
  email.numOfSticks = state.pipeBed.numberOfPipeSticks;
  email.pipeStorage = 0;// TODO
  email.numOfSingleTees = 0;// TODO
  email.numOfDoubleTees = 0;// TODO
  email.numOfTripleTees = 0;// TODO
  email.numOfBends = state.pipeBed.numberOfManifoldCorners;
  email.numOfRows = state.pipeBed.numberOfPipeRows;

  email.maxLength = formatNum(state.pipeBed.stoneBedDimensions.height.ft);
  email.maxWidth = formatNum(state.pipeBed.stoneBedDimensions.width.ft);
  email.approxBedSize = formatNum(state.pipeBed.area);
  email.amountStone = formatNum(pipeSelectors.pipeStoneBedAmount(state) / Math.pow(3, 3)) || 0;
  email.excavationVolume = formatNum(pipeSelectors.pipeTotalExcavation(state) / Math.pow(3, 3)) || 0;

  // console.log("Submission", email);
  /* set the email */
  project.setEmail(email);

  /* return the project */
  return project;
};

/**
 * The Chambers Project automation class.
 */
export const buildProjectAutomation = () => ( dispatch, getState ) => {
  // get tue current state
  let state = getState();

  // if (projectInstance !== null && projectInstance.silentState) {
  //     const silentState = projectInstance.silentState;
  //     console.log('silentState', silentState);
  //     state = {...state, ...silentState};
  // }

  // collecting all necessary properties
  let stage = window.konvaStage;
  let scalePixels = state.globals.scalePixels;
  let scaleValue = state.globals.scaleValue;
  let chamberType = state.globals.chamberType;
  let chamberEndCapType = state.globals.chamberEndCapType;
  let chamberRowSpacing = state.globals.chamberRowSpacing;
  let perimeterStoneOffset = state.stonebed.sepDistance;
  let chamberRows = state.chamberbed.chamberRows;
  let chamberBedScaleX = state.chamberbed.scaleX;
  let chamberBedScaleY = state.chamberbed.scaleY;
  let chamberBedHeight = state.chamberbed.height;
  let chamberBedWidth = state.chamberbed.width;
  let hasCornerOutlet = state.chamberbed.hasCornerOutlet;
  let hasPerimeterOutlet = !!( ManifoldSelectors.getManifoldsByPurpose("outlet").find(m => m.isManifoldInner) );
  let storageVolume = state.calculations.storageVolume;
  let porousStoneAbove = state.calculations.porousStoneAbove;
  let porousStoneBelow = state.calculations.porousStoneBelow;
  let porosityPercent = state.calculations.porosityPercent;
  let baseStoneElevation = state.calculations.baseStoneElevation;
  let underDrain = state.calculations.underdrain;
  let underdrainToggle = state.calculations.underdrain;
  let totalStorageProvided = state.calculations.totalStorageProvided;
  let imperviousLiner = state.chamberbed.imperviousLiner;
  let numberOfFeedConnectors = state.chamberbed.feedConnectors.numberOfFeedConnectors;
  let linerSqInchOverage = state.calculations.linerSqInchOverage;

  // is background showing
  let bgShow = state.background.bgShow;

  // get the components from stage
  let background = stage.find("#background")[0];
  let chamberBed = stage.find("#chamberBed")[0];
  let rows = stage.find(".chamberRow");
  let chambers = stage.find(".chamber");
  let endcaps = stage.find(".endcap");
  let stoneBedCircles = stage.find(".stoneBedPoint");
  let chamberBedCenterPoint = stage.find("#chamberBedCenterPoint")[0];


  const upperManifolds = ManifoldSelectors.getFullManifoldsByType("upper");
  const lowerManifolds = ManifoldSelectors.getFullManifoldsByType("lower");

  // the project object
  let project = new Project();

  // set the user localization settings
  project.setRegion(state.localization.region.name);
  project.setLanguage(state.localization.language.name);
  project.setUnits(state.localization.unit);

  // extract the chamber bed properties
  let bedRotation = ( chamberBed !== undefined )
    ? chamberBed.rotation()
    : 0;

  let bedX = ( chamberBed !== undefined )
    ? chamberBed.x()
    : 0;

  let bedY = ( chamberBed !== undefined )
    ? chamberBed.y()
    : 0;

  let bedHeight = chamberBedHeight * chamberBedScaleY;
  let bedWidth = chamberBedWidth * chamberBedScaleX;

  // instance the chamber bed serialization object
  let chmBd = new ChamberBed(bedX, bedY, bedRotation, bedWidth, bedHeight);

  // add chamber bed to project
  project.addChamberBed(chmBd);

  // if background is present
  if (background && bgShow) {
    // extract the chamber bed properties
    let bgRotation = background.rotation();
    let bgX = background.x();
    let bgY = background.y();
    let bgHeight = background.height();
    let bgWidth = background.width();
    let bgScaleX = background.scaleX();
    let bgScaleY = background.scaleY();
    // extracting background data
    let bgData = backgroundToPNG(background);

    // instance the background serialization object
    let bg = new Background(
      bgX,
      bgY,
      bgScaleX,
      bgScaleY,
      bgRotation,
      bgWidth,
      bgHeight,
      bgData
    );
    // add background to project
    project.addBackground(bg);
  }

  // translate the stone bed circles to absolute coordinates
  if (stoneBedCircles.length) {
    // instance the stone bed serialization object
    let stoneBed = new StoneBed();
    // extract the chamber bed properties
    stoneBedCircles.forEach(chamberBedProperty => {
      stoneBed.addPoint(
        parseInt(chamberBedProperty.id(), 10),
        chamberBedProperty.getAbsolutePosition().x,
        chamberBedProperty.getAbsolutePosition().y
      );
    });
    // add chamber bed to project
    project.addStoneBed(stoneBed);
  }

  // for each row, instance and add to chamber bed
  rows.forEach(rowOnStage => {
    // the row metadata
    let row = chamberRows[rowOnStage.id()];
    let activeChambers = row.getActiveCount();

    // if not active chambers return
    if (!activeChambers) {
      return;
    }
    // the properties
    let rowNum = rowOnStage.id();
    let offSet = row.offSet;
    let x = rowOnStage.x();
    let y = rowOnStage.y();
    let absolutePositionX = rowOnStage.getAbsolutePosition().x;
    let absolutePositionY = rowOnStage.getAbsolutePosition().y;
    let pixelOffset = row.pixelOffSet;
    let height = row.height;
    let width = row.width;
    let rotation = rowOnStage.rotation();
    let absoluteRotation = rotation + bedRotation;

    // instance the stone bed serialization object
    let chamberRow = new ChamberRow(
      rowNum,
      offSet,
      x,
      y,
      absolutePositionX,
      absolutePositionY,
      pixelOffset,
      height,
      width,
      rotation,
      absoluteRotation
    );

    // add chamber row to chamber bed
    chmBd.addRow(rowNum, chamberRow);
  });

  // for each chamber, instance and add to chamber bed's corresponding row
  chambers
    .forEach(chamberOnStage => {
      // the chamber parent on Konva Stage
      let parentChamber = chamberOnStage.getParent();

      // The chamber properties
      let id = chamberOnStage.id().split("-");
      let row = parseInt(id[0], 10);
      let col = parseInt(id[1], 10);
      let x = parentChamber.x();
      let y = parentChamber.y();
      let height = parentChamber.height();
      let width = parentChamber.width();
      let absolutePositionX = parentChamber.getAbsolutePosition().x;
      let absolutePositionY = parentChamber.getAbsolutePosition().y;
      let rotation = parentChamber.rotation();
      let absoluteRotation = rotation + bedRotation;

      // Instance the chamber serialization object
      let cmb = new Chamber(
        row,
        col,
        x,
        y,
        height,
        width,
        absolutePositionX,
        absolutePositionY,
        rotation,
        absoluteRotation
      );

      // The metadata from the chamber object on state
      let chamberMetadata = chamberRows[row].chambers[col];

      // add accessory if present, add it to collection
      if (
        chamberMetadata.accessory &&
        chamberMetadata.accessory.id &&
        chamberMetadata.accessory.id !== "none"
      ) {
        cmb.addAccessory(chamberMetadata.accessory);
      }
      // add isolator data if present to the array
      cmb.isIsolator = false;
      if (
        chamberMetadata._isIsolatorArray && chamberMetadata._isIsolatorArray.length > 0
      ) {
        cmb.isIsolatorArray = chamberMetadata._isIsolatorArray;
        cmb.isIsolator = true;
      }

      // add chamber row to chamber bed
      chmBd.addChamber(row, col, cmb);
    });

  // for each endCap, instance and add to chamber bed's corresponding chamber
  endcaps
    .forEach(endCapOnStage => {
      // the chamber parent
      let p = endCapOnStage.getParent();
      // the chamber properties
      let id = endCapOnStage.id().split("-");
      let row = parseInt(id[0], 10);
      let col = parseInt(id[1], 10);
      let position = id[2];
      let x = p.x();
      let y = p.y();
      let height = p.height();
      let width = p.width();
      let absolutX = p.getAbsolutePosition().x;
      let absolutY = p.getAbsolutePosition().y;
      let rotation = p.rotation();
      let absolutRotation = rotation + bedRotation;

      // instance the endcap serialization object
      let endcap = new EndCap(
        row,
        col,
        x,
        y,
        height,
        width,
        absolutX,
        absolutY,
        rotation,
        absolutRotation
      );

      // the metadata from the object on state
      let chamber = chamberRows[row].chambers[col];

      // the property to get depending if endcap is lower or upper
      let endCapAccessoryProp;

      // determine the property of this endcap
      switch (position) {
        case ENDCAP_POSITION_LOWER:
          endCapAccessoryProp = "lowerCapAccessory";
          break;

        case ENDCAP_POSITION_UPPER:
          endCapAccessoryProp = "upperCapAccessory";
          break;

        default:
          throw new Error("Not valid endCap position.");
      }

      // add accessory if present, add it to collection
      if (
        chamber[endCapAccessoryProp] &&
        chamber[endCapAccessoryProp].id &&
        chamber[endCapAccessoryProp].id !== "none"
      ) {
        endcap.addAccessory(chamber[endCapAccessoryProp]);
      }

      // add chamber row to chamber bed
      chmBd.addEndCap(row, col, position, endcap);
    });

  // sort chambers before submissions, this fixes the under drain issue: CW-251
  chmBd.rows
    .forEach(row => {
      row.chambers.sort(( a, b ) => a.row <= b.row && a.col <= b.col ? -1 : 1);
    });


  // adding manifold metadata
  // correcting under drain when we have an outlet, not in the corner
  if (!hasCornerOutlet && !hasPerimeterOutlet) underDrain = false;
  const requestStructureObj = {
    chamberTypeId: chamberType.id,
    state: {
      adsUnits: state.localization.unit,
      rowGap: chamberRowSpacing * 12,
      rowSpacing: chamberRowSpacing,
      perimeterStoneOffset: perimeterStoneOffset,
      isUnderDrainEnabled: ( !hasCornerOutlet && !hasPerimeterOutlet ) ? false : !!( underDrain ),
      chamberRows: state.chamberbed.chamberRows
    }
  };
  const upper = ManifoldUtils.buildManifoldsPayloadArray(upperManifolds, requestStructureObj);
  project.addManifoldsByArray(upper);
  const lower = ManifoldUtils.buildManifoldsPayloadArray(lowerManifolds, requestStructureObj);
  project.addManifoldsByArray(lower);

  project.manifold = JSON.stringify(project.manifold);

  // adding metadata and types
  project.setChamberType(chamberType);
  project.setChamberEndCapType(chamberEndCapType);
  project.setRowSeparation(chamberRowSpacing);
  project.setScaleValue(scaleValue);
  project.setScalePixels(scalePixels);
  project.setStorageVolume(storageVolume);  // storageVolume
  project.setPorousStoneAbove(porousStoneAbove);
  project.setPorousStoneBelow(porousStoneBelow);
  project.setPorosityPercent(porosityPercent);
  project.setBaseStoneElevation(baseStoneElevation);
  project.setUnderdrain(underDrain && ( ( hasCornerOutlet !== null && hasCornerOutlet ) || ( hasPerimeterOutlet ) ));
  project.setUnderdrainToggle(underdrainToggle);
  project.setImperviousLiner(imperviousLiner);
  project.setLinerSqInchOverage(linerSqInchOverage);
  project.setTotalStorageProvided(totalStorageProvided);
  project.setChamberBedCenterPoint(
    chamberBedCenterPoint.getAbsolutePosition().x,
    chamberBedCenterPoint.getAbsolutePosition().y
  );

  let email = new Email();
  // set project email info
  let projectInfo = state.project.project || state.project.projectInfo;

  // init email data
  email.name = "";
  email.projectname = "";
  email.engineer = "";
  email.location = "";
  email.city = "";
  email.state = "";
  email.country = "";
  email.drawingsURL = "";
  email.boomURL = "";
  email.isInternal = false;
  email.chamber = state.globals.chamberType.name || "";

  // validate email address
  if (
    state.authentication.user &&
    state.authentication.user.mail
  ) {
    // set the full name
    let fullName = `${state.authentication.user.givenName} ${state.authentication.user.surname}`;
    email.to = state.authentication.user.mail;
    email.fullName = fullName;
    email.phone =
      state.authentication.user.mobilePhone || "NO_PHONE_PROVIDED";
    email.company =
      state.authentication.user.companyName || "NO_COMPANY_PROVIDED";
    // collect the initials
    let initials = fullName.match(/\b\w/g) || [];
    email.engineer = ( ( initials.shift() || "" ) + ( initials.pop() || "" ) ).toUpperCase();
    project.engineer = email.engineer;
  } else {
    console.warn("No user/email present to provide email address for submission", state.authentication.user);
  }

  let projectLang = getLanguageByName(project.language);

  email.outlet = state.calculations.hasOutlet
    ? state.localization.content[projectLang.id].yes
    : state.localization.content[projectLang.id].no;

  if (projectInfo !== null) {
    try {
      email.name = projectInfo.projectName || email.name;
      email.projectname = projectInfo.projectName || email.projectname;

      if (projectInfo.region === getRegionById(regionIds.usa).name) {
        email.location = getStateAbbreviation(projectInfo.state) || projectInfo.state;
      } else if (projectInfo.region === getRegionById(regionIds.canada).name) {
        email.location = getCAProvincesAbbreviation(projectInfo.state) || projectInfo.state;
      } else if (projectInfo.region === getRegionById(regionIds.mexico).name) {
        email.location =
          getMXProvincesAbbreviation(projectInfo.state) || projectInfo.state;
      } else {
        email.location = projectInfo.country || email.location;
      }

      email.unitName = ( state.localization.unit === "imperial" )
        ? state.localization.content[projectLang.id].imperial
        : state.localization.content[projectLang.id].metric;

      if (projectInfo.region === getRegionById(regionIds.usa).name) {
        email.state = getStateAbbreviation(projectInfo.state) || projectInfo.state;
      } else if (projectInfo.region === getRegionById(regionIds.canada).name) {
        email.state = getCAProvincesAbbreviation(projectInfo.state) || projectInfo.state;
      } else if (projectInfo.region === getRegionById(regionIds.mexico).name) {
        email.state =
          getMXProvincesAbbreviation(projectInfo.state) || projectInfo.state;
      } else {
        email.state = projectInfo.region;
      }

      email.city = projectInfo.city || email.city;
      email.country = projectInfo.region;

    } catch (exception) {
    }  // Ignore
  }

  email.requiredvolume = formatNum(state.calculations.storageVolume) || 0;
  email.porosity = formatNum(state.calculations.porosityPercent) || 0;
  email.stoneBelow = formatNum(state.calculations.porousStoneBelow) || 0;
  email.stoneAbove = formatNum(state.calculations.porousStoneAbove) || 0;
  email.baseStoneElevation = formatNum(state.calculations.baseStoneElevation) || 0;
  email.avgCover = formatNum(state.calculations.averageCover) || 0;
  email.availableLength = formatNum(state.calculations.availableLength);
  email.availableWidth = formatNum(state.calculations.availableWidth);
  email.installedVolume = formatNum(state.calculations.totalStorageProvided) || 0;
  email.chamberStorage = formatNum(chamberType.storage) || 0;
  email.numOfChambers = formatNum(state.calculations.requiredChambers) || 0;
  email.numOfEndcaps = formatNum(state.calculations.requiredEndCaps) || 0;
  email.numOfRows = formatNum(state.calculations.numberOfRows) || 0;
  email.chamberType = formatNum(state.calculations.chamberType) || 0;
  // calculate the average length of system
  email.avgRowLength = calculateAverageRowLen(email.numOfChambers, email.numOfRows, chamberType, chamberEndCapType);

  email.maxLength = formatNum(state.calculations.systemLength) || 0;
  email.maxWidth = formatNum(state.calculations.systemWidth) || 0;
  email.approxBedSize = formatNum(state.calculations.rectangularFootprint);
  email.amountStone = formatNum(state.calculations.amountOfStone / Math.pow(3, 3));
  email.excavationVolume = formatNum(state.calculations.totalExcavation / Math.pow(3, 3));

  email.nonWoven = Math.round(state.calculations.geotextileQuantities.nonWoven);
  email.nonWovenIsolator = Math.round(state.calculations.geotextileQuantities.nonWovenIsolator);
  email.nonWovenTotal = Math.round(state.calculations.geotextileQuantities.nonWovenTotal);
  email.woven = Math.round(state.calculations.geotextileQuantities.woven);
  email.wovenIsolator = Math.round(state.calculations.geotextileQuantities.wovenIsolator);
  email.wovenTotal = Math.round(state.calculations.geotextileQuantities.wovenTotal);
  email.showNonWovenBreakdown =
    [CHAMBER_TYPE_ID_SC160LP, CHAMBER_TYPE_ID_SC310, CHAMBER_TYPE_ID_SC740].indexOf(chamberType.id) > -1;

  email.imperviousLiner = imperviousLiner;
  email.numberOfFeedConnectors = numberOfFeedConnectors;
  email.linerSqInchOverage = Math.round(state.calculations.linerSqInchOverage);
  email.maximumAllowableCover =
    formatNum(parseFloat(state.calculations.baseStoneElevation) + chamberType.maxCover) || 0;
  email.minimumAllowableCover =
    formatNum(parseFloat(state.calculations.baseStoneElevation) + chamberType.minInstalledDepth) || 0;
  // set the email
  project.setEmail(email);

  const debugProjectSubmit = true;
  if (debugProjectSubmit) {
    console.log("%c buildProjectAutomation() === ", "color:red; background-color:yellow;", project);
  }
  return project;
};

/**
 * Calculates average row length of the system.
 * @param numChambers
 * @param activeRowsCnt
 * @param chamberType
 * @param chamberEndCapType
 */
function calculateAverageRowLen( numChambers, activeRowsCnt, chamberType, chamberEndCapType ) {
  // calculate total length
  return ( numChambers / activeRowsCnt ) * chamberType.length +
    ( activeRowsCnt ? 2 * chamberEndCapType.length : 0 );
}



// WEBPACK FOOTER //
// ./src/actions/submit-dialog-actions.js